import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MODALS, PERMISSIONS } from '../../../../constants';
import { checkPermisson, getLeagues } from '../../../../selectors/common';
import { getLiveTemplate } from '../../../../selectors/teams';
import PlayersTemplate from '../..';
import { aGetLiveTemplateRequest } from '../../../../reducers';
import { aSetOpenModal } from '../../../../reducers/common';

const mapToProps = (state) => ({
  liveTemplate: getLiveTemplate(state),
  competitions: getLeagues(state),
  checkPermisson: (payload) => checkPermisson(state, payload),
});

const actionsToProps = (dispatch) => ({
  getLiveTemplateRequest: (payload) => dispatch(aGetLiveTemplateRequest(payload)),
  setOpenModal: (payload) => dispatch(aSetOpenModal(payload)),
});
class LiveTemplate extends Component {
  constructor(props) {
    super(props);

    this.hasPermissionTo = {
      add: props.checkPermisson(PERMISSIONS.LIVE_TEMPLATES_APPLY),
      view: props.checkPermisson(PERMISSIONS.LIVE_TEMPLATES_VIEW),
    };
  }

  componentDidMount() {
    this.props.getLiveTemplateRequest();
  }

  render() {
    return (
      <PlayersTemplate
        hasPermissionToAdd={this.hasPermissionTo.add}
        hasPermissionToView={this.hasPermissionTo.view}
        leagues={this.props.competitions}
        addModalName={MODALS.LIVE_TEMPLATE_ADD}
        playersTemplate={this.props.liveTemplate}
        addBtnLabel="New Live Template"
      />
    );
  }
}

export default connect(mapToProps, actionsToProps)(LiveTemplate);
